import { useQuery } from "@tanstack/react-query";

import { AvatarList } from "@/components/canvas-editor/components/AvatarList";
import {
  BlockSeparator,
  ListAttribution,
} from "@/components/canvas-editor/components/Container";
import { Spinner } from "@/components/Spinner";
import { SimpleTooltip } from "@/components/ui/tooltip";
import { getStarterPackQueryOptions } from "@/lib/api";

export function StarterPackPreview({
  starterPackUrl,
  hasSeparator = true,
}: {
  starterPackUrl: string;
  hasSeparator?: boolean;
}) {
  const { data: starterPack, isPending } = useQuery(
    getStarterPackQueryOptions(starterPackUrl),
  );

  return (
    <>
      {starterPack && starterPack.asset_metadata?.starter_pack ? (
        <>
          {hasSeparator && <BlockSeparator />}
          <ListAttribution
            avatar={starterPack.asset_metadata.starter_pack.list.avatar}
            name={starterPack.asset_metadata.starter_pack.list.name}
            creator={starterPack.asset_metadata.starter_pack.creator}
          >
            <SimpleTooltip message="Total members">
              <span className="text-slatea-12 dark:text-slatedarka-12 bg-slatea-2 dark:bg-slatedarka-2 rounded-md px-2 py-1 text-xs border border-slatea-5 dark:border-slatedarka-5">
                {starterPack.asset_value.length}
              </span>
            </SimpleTooltip>
          </ListAttribution>
          <BlockSeparator />
          <AvatarList
            users={starterPack.asset_metadata.starter_pack.list_items_sample.map(
              (item) => item.subject,
            )}
            total={starterPack.asset_value.length}
          />
        </>
      ) : isPending ? (
        <div className="flex justify-center items-center p-2 h-8">
          <Spinner delay={1000} />
        </div>
      ) : (
        <div className="text-sm text-slate-11 dark:text-slatedark-11 p-2">
          This starter pack is not yet in our system. Please verify the starter
          pack URL and wait a few minutes for it to be indexed.
        </div>
      )}
    </>
  );
}
